import styled from 'styled-components';
import { colors } from '../ui-elements/Main/MainTheme';

/*
  Always-on "Schedule Demo" CTA for trial users. Docked in the header's
  right-hand cluster just before the utility icons (see Root.tsx), so it
  keeps a fixed spot regardless of which TrialHeader funnel stage is
  showing. Rendered as a compact dark-green OUTLINE pill — deliberately
  secondary to the filled-green "Verify Phone" primary CTA — and links
  straight into Luis' Calendly demo booking page in a new tab.
*/
/*
  Visibility gate for the docked Schedule Demo CTA, extracted as a pure
  predicate so the render logic is unit-testable without mounting the whole
  header. Show only for trial accounts, on desktop (the mobile header has no
  room — a persistent mobile trial nudge is tracked separately), and never
  while the app is in a downtime state.
*/
export const shouldShowScheduleDemo = (
  { isTrial, isMobile, isDown }: { isTrial: boolean; isMobile: boolean; isDown: boolean },
): boolean => isTrial && !isMobile && !isDown;

export const ScheduleDemoButton = () => (
  <DemoLink
    href="https://calendly.com/luis-01/new-meeting"
    target="_blank"
    rel="noopener noreferrer"
    onClick={(e) => e.stopPropagation()}
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="4.5" width="18" height="16.5" rx="3" stroke="currentColor" strokeWidth="2" />
      <path d="M3 9h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M8 2.5v4M16 2.5v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
    <Label>Schedule Demo</Label>
  </DemoLink>
);

const Label = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-weight: 700;
`;

const DemoLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
  height: 38px;
  padding: 0 16px;
  margin: 0 6px;
  border-radius: 50px;
  background: transparent;
  border: 1.5px solid ${colors.darkGreen};
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease;

  /*
    Color the CHILDREN (icon + label) directly rather than the <a>
    itself. The browser's UA link color lives on the anchor and only
    *inherits* down, so an explicit color on a child element always
    wins — this dodges the :link/:visited/:hover recolor quirk that
    left the text stuck on link-blue.
  */
  svg,
  ${Label} {
    flex-shrink: 0;
    color: ${colors.darkGreen};
    transition: color 0.15s ease;
  }

  &:hover {
    background: ${colors.darkGreen};
  }
  &:hover svg,
  &:hover ${Label} {
    color: #fff;
  }
`;
